module.exports = __webpack_public_path__ + "img/headshot-cid-ford@2x.179cadde.jpg";